import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Input,
  Output,
  ViewChildren,
  QueryList,
  NgZone,
  ɵConsole,
  EventEmitter
} from '@angular/core';
import { FormGroup, FormControl, Validators,FormArray,FormBuilder, Form } from '@angular/forms';
import { DataService } from '../../services/data.service';
import bsCustomFileInput from 'bs-custom-file-input';
import { almenosUnImpactoValidator } from '../../validators/validadores.validator';
import { ModalProcedimientoComponent } from 'src/app/components/modal-procedimiento-asis/modal-procedimiento.component';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { Iniciativa, Impactos,DireccionGral,DireccionArea} from 'src/app/interfaces/interfaces';
import * as moment from 'moment';
import { MatDialog} from '@angular/material/dialog';
import { AuthService } from '../../services/auth.service';
import { ModalCosteoConsultaComponent } from 'src/app/components/modal-costeo-consulta/modal-costeo-consulta.component';
import {STEPPER_GLOBAL_OPTIONS} from '@angular/cdk/stepper';
import { Proceso, Procedimiento } from 'src/app/interfaces/interfaces';
import{ ConfirmComponent} from 'src/app/components/shared/confirm/confirm.component';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';


@Component({
  selector: 'app-nuevo-sistema',
  templateUrl: './nuevo-sistema.component.html',
  styleUrls: ['./nuevo-sistema.component.scss'],
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: {showError: true}
  }]
})
export class NuevoSistemaComponent implements OnInit {
  // Usuario autenticado
  @Input() emailUser: string;
  @Input() nombreUser: string;
  //Evento de salida para el boton de siguiente, ventana costeo
  @Output() botonSiguiente = new EventEmitter<number>();
  @Output() id:number;

  // control de visibilidad de los componentes del form
  inContibucionGobierno = false;
  inContibucionOperativo = false;
  inImpactoProcesos = false;
  inMejorarServicioCiudadania = false;
  inCumplimientoLey = false;
  inModernizacionDependencia = false;
  // Objeto de los forms
  nuevoSisFormDatos: FormGroup;
  editarSisFormDatos: FormGroup;
  json_impactoimp: FormGroup;
  formArchivos: FormGroup;

  // Visivilidad de los uploadings de los archivos
  subiendoProcesoActual = false;
  subiendoProcesoPropuesto = false;
  subiendoCosteo = false;
  subiendoOtrosArchivos = false;
  procesoActualError = false;
  procesoPropuestoError = false;
  costeoError = false;
  otrosArchivosError = false;
  // Valores de los input Files
  @ViewChild('procesoActual', { static: true })
  procesoActualInput: ElementRef;
  @ViewChild('procesoPropuesto', { static: true })
  procesoPropuestoInput: ElementRef;
  @ViewChild('costeo', { static: true })
  costeoInput: ElementRef;
  @ViewChild('otrosArchivos', { static: true })
  otrosArchivosInput: ElementRef;
  // Checkboxes
  @ViewChildren('checkboxes') checkboxes: QueryList<ElementRef>;

  @ViewChild('labelProcesoPropuesto',{static:false})
  labelProcesoPropuesto: ElementRef;
  @ViewChild('labelProcesoActual',{static:false})
  labelProcesoActual: ElementRef;
  @ViewChild('labelAnexos',{static:false})
  labelAnexos: ElementRef;

  // limite para campo fecha
  fechaActual: number;
  mostrardescargarArchivoPA:boolean=false;
  mostrardescargarArchivoPP:boolean=false;
  mostrardescargarArchivoAN:boolean=false;
  nombreArchivoPP:string;
  nombreArchivoPA:string;
  nombreArchivoAN:string;
  idIniciativa:string;
  opcion:string;
  idProceso:number;
  botonCosteo:boolean=false;
  mostrarCosteo:boolean=false;
  mostrarFormNuevo:boolean=true;
  mostrarFormConsultar:boolean=false;
  mostrarFormEditar:boolean=false;
  checkSeleccionado:boolean=false;
  selected: any = [];
  arrayImpactos: Impactos[]=[];
  arrayImpactosConsulta: Impactos[]=[];
  archivoAnexo:File;
  archivoPropuesto:File;
  archivoActual:File;
  direccionesGral: DireccionGral[];
  direccionesArea: DireccionArea[];
  areaGralSeleccionada: string;
  @ViewChild(ModalCosteoConsultaComponent) consultaCosteo: ModalCosteoConsultaComponent;
  @ViewChild(ModalProcedimientoComponent) editUserComponent: ModalProcedimientoComponent;

formProcesos: FormGroup;
costeo:boolean;
tablaProcedimientos: Procedimiento[]=[];
tablaProcedimientosToBe: Procedimiento[]=[];
tabla: Procedimiento[]=[];
tabuladores: any[]=[];
archivoProcesoActualRequerido:boolean=false;
archivoProcesoPropuesto:boolean=false;
botonEnviar:boolean=false;
fechaTermino: string;
tabs = ['Procedimiento'];
selectedTabs = new FormControl(0);
tabSeleccionado:number=0;
loadingGeneral:boolean=false;
esPeriodoEnvio:boolean=false;
idRolSeleccionado:number;
valorTaps:number=0;
loading:boolean=false;
idDirGral:number;
nameDirGral:string;

  constructor(
    public dialog:MatDialog,
    private dataService: DataService,
    private zone: NgZone,
    private router: Router,
    private notifier: NotifierService,
    private authService: AuthService,
    private _formBuilder: FormBuilder
  ) {
    this.fechaActual = Date.now();
    /*this.authService.user.subscribe((user: string) => {
      {this.emailUser = user}
      //return this.emailUser;
    });*/
    //Verificamos que sea periodo de envio
    this.dataService.esPeriodoEnvios().subscribe(
      data=>{
        this.esPeriodoEnvio=data['objData'];
      }
    );
  }

  ngOnInit() 
  {
       //Nos subscribimos al método para el rol seleccionado
    this.authService.escuchaRolSeleccionado().subscribe((res) => {
      this.idRolSeleccionado = res;
    });
    this.authService.obtenerEmailUser().subscribe((res) => {
      this.emailUser = res;
    });
     this.idIniciativa = localStorage.getItem ("editarIniciativaId");
     this.opcion = window.localStorage.getItem ("opcionTabla");
     if (!this.idIniciativa) 
     {
     }
     else{
       //Opcion para consultar
       if(parseInt(this.opcion)==2)
       {
        this.verDetallesIniciativa(parseInt(this.idIniciativa));
         this.mostrarFormConsultar=true;
         this.mostrarFormNuevo=false;
       }
       //Opcion para editar
       if(parseInt(this.opcion)==1)
       {
        this.botonCosteo=true;
        this.mostrarFormNuevo=false;
        this.mostrarFormEditar=true;
        this.verDetallesIniciativa(parseInt(this.idIniciativa));
       }

     }
     
    // Activar el FileChooser de bootstrap
    bsCustomFileInput.init();
    // Crear form
    this.nuevoSisFormDatos = this._formBuilder.group({
      id_proceso: new FormControl(''),
      id_iniciativa: new FormControl(''),
      nombre_iniciativa: new FormControl(''),
      nombre_solicitante: new FormControl(''),
      email_solicitante: new FormControl('',  [Validators.email]),
      direccionArea_solicitante: new FormControl(''),
      telefono_solicitante: new FormControl('', [Validators.maxLength(10)]),
      extencion_solicitante: new FormControl(''),
      problematica_iniciativa: new FormControl(''),
      fechaTermino_iniciativa: new FormControl(''),
      justificacionFecha_iniciativa: new FormControl(''),
      numeroTransacciones_iniciativa:new FormControl(''),
      folio_iniciativa:new FormControl(''),
      fechaEnvio_iniciativa: new FormControl(''),
      id_tipoIniciativa: new FormControl(''),
      id_area : new FormControl(''),
      id_aplicativo: new FormControl(''),
      id_estatusIniciativa: new FormControl(''),
      userLogin: new FormControl(this.emailUser),
      rolUserlogin:new FormControl(this.idRolSeleccionado),
      contribucionProgGobierno: new FormControl(''),
      contribucionProgOperativo: new FormControl(''),
      impactoProcesos: new FormControl(''),
      mejoraServicio: new FormControl(''),
      cumplimientoLey: new FormControl(''),
      contribucionModernizacion: new FormControl(''),
      json_impacto:new FormControl(''),
      dirGral_solicitante:new FormControl(''),
      id_dirgralSapSolicitante:new FormControl(''),
      id_areaSapSolicitante:new FormControl(''),

      //FormGroup para los impactos
      json_impactoimp: new FormGroup(
      {
          contribucionProgGobierno: new FormControl(''),
          contribucionProgOperativo: new FormControl(''),
          impactoProcesos: new FormControl(''),
          mejoraServicio: new FormControl(''),
          cumplimientoLey: new FormControl(''),
          contribucionModernizacion: new FormControl('')
        },
        //almenosUnImpactoValidator()
      ),
      solucionPropuesta_iniciativa: new FormControl(''),
      beneficiariosDirectos_iniciativa: new FormControl(''),
      beneficiariosImplementacion_iniciativa: new FormControl(''),
      nombreProceso_iniciativa: new FormControl(''),
      //Documentos
      doc_procesoActual: new FormControl(''),
      doc_procesoPropuesto: new FormControl(''),
      docAnexos_iniciativas: new FormControl(''),
    });

    //Form para guardar la info de los archivos
    this.formArchivos=this._formBuilder.group({
      doc_procesoActual: new FormControl(''),
      doc_procesoPropuesto: new FormControl(''),
      docAnexos_iniciativas: new FormControl('')

    });


    this.formProcesos= this._formBuilder.group({
      id_proceso:new FormControl(''),
      id_iniciativa: new FormControl(''),
      nombre_proceso: new FormControl(''),
      procedimiento_proceso: new FormControl(''),
      duenio_proceso: new FormControl(''),
      tramitesExternosASIS_proceso: new FormControl(''),
      tramitesInternosASIS_proceso: new FormControl(''),
      tramitesExternosTOBE_proceso: new FormControl(''),
      tramitesInternosTOBE_proceso: new FormControl(''),
      hojasImpresasASIS_proceso : new FormControl(''),
      hojasImpresasTOBE_proceso : new FormControl(''),
      kmRecorridosASIS_Proceso: new FormControl(''),
      kmRecorridosTOBE_Proceso: new FormControl(''),
      archivo_costeo:new FormControl('')
    })


    // Crear form
    this.editarSisFormDatos = new FormGroup({
      id_proceso: new FormControl(''),
      id_iniciativa: new FormControl(''),
      nombre_iniciativa: new FormControl(''),
      nombre_solicitante: new FormControl(''),
      email_solicitante: new FormControl('',  [Validators.email]),
      direccionArea_solicitante: new FormControl(''),
      telefono_solicitante: new FormControl('', [Validators.maxLength(10)]),
      extencion_solicitante: new FormControl('', [Validators.maxLength(5)]),
      problematica_iniciativa: new FormControl(''),
      fechaTermino_iniciativa: new FormControl(''),
      justificacionFecha_iniciativa: new FormControl(''),
      numeroTransacciones_iniciativa:new FormControl(''),
      folio_iniciativa:new FormControl(''),
      fechaEnvio_iniciativa: new FormControl(''),
      id_tipoIniciativa: new FormControl(''),
      id_area : new FormControl(''),
      id_aplicativo: new FormControl(''),
      id_estatusIniciativa: new FormControl(''),
      impactosArray: new FormArray([]),
      userLogin: new FormControl(this.emailUser),
      solucionPropuesta_iniciativa: new FormControl(''),
      beneficiariosDirectos_iniciativa: new FormControl(''),
      beneficiariosImplementacion_iniciativa: new FormControl(''),
      nombreProceso_iniciativa: new FormControl(''),
      json_impacto:new FormControl(''),
      dirGral_solicitante:new FormControl(''),
      id_dirgralSapSolicitante:new FormControl(''),
      id_areaSapSolicitante:new FormControl(''),
      json_impactoimp: new FormGroup(
        {
            contribucionProgGobierno: new FormControl(''),
            contribucionProgOperativo: new FormControl(''),
            impactoProcesos: new FormControl(''),
            mejoraServicio: new FormControl(''),
            cumplimientoLey: new FormControl(''),
            contribucionModernizacion: new FormControl('')
          },
          almenosUnImpactoValidator()
        ),
      //Impactos
         contribucionProgGobierno: new FormControl(''),
          contribucionProgOperativo: new FormControl(''),
          impactoProcesos: new FormControl(''),
          mejoraServicio: new FormControl(''),
          cumplimientoLey: new FormControl(''),
          contribucionModernizacion: new FormControl(''),
      //Documentos
      doc_procesoActual: new FormControl(''),
      doc_procesoPropuesto: new FormControl(''),
      docAnexos_iniciativas: new FormControl('')
    });

      //Obtener las direcciones generales
    this.dataService.obtenerDireccionGral(parseInt(this.idIniciativa),this.emailUser).subscribe(data => {
      this.direccionesGral = data['data'];
    });
    //Obtenemos la informacion de usuario logueado
    this.dataService.obtenerInfoUsuario(this.emailUser).subscribe(data => {
      if(data['objData'])
      {
        this.idDirGral=data['objData']['id_dirgralSap'];
        this.nameDirGral=data['objData']['nombre_dirgralSap'];

            //Hacemos el patchValue para la direccion gral
          this.nuevoSisFormDatos.patchValue({
            id_dirgralSapSolicitante:this.idDirGral
          })
      this.dataService.obtenerAreaSolicitante(this.idDirGral).subscribe(
        data => {
          if (data['data']) {
            this.direccionesArea = data['data'];
          }
        },
        error => {
        }
      );
      }
    });
    
  }

  get fc() {
    return this.nuevoSisFormDatos.controls;
  }
  get f() {
    return this.nuevoSisFormDatos;
  }

  //Método para agregar tabs
  addTab(selectAfterAdding: boolean) {
    this.tabs.push(`Procedimiento ${this.tabs.length + 1}`); 
    let nuevoTab=this.tabs.length + 1;
    this.selectedTabs.setValue(nuevoTab);
    this.formProcesos.reset();
  }

  //Eliminar procesos del costeo
  deleteProcesos(index:number, tab:number)
  {
    this.loadingGeneral=true;
    this.tabs.splice(index, 1);
    this.tabuladores.forEach((element, index) => {
      if(tab==index)
      {
        //Eliminamos el proceso
        this.dataService.deleteProcesoCosteo(element).subscribe(
          data => {
            if (data['objData']) {
              this.notifier.notify(
                'success',
                'Proceso eliminado correctamente.'
              );
            }
          },
          error => {
            this.notifier.notify(
              'error',
              'Ha ocurrido un error al intentar eliminar el proceso. Verifique su conexión de red o contacte al administrador.'
            );
          }
        );
      }//If de los tabuladores
     });
     //Eliminar el tabulador
     //this.tabuladores.splice(tab,1);
     this.tabuladores=[];
     this.tabla=[];
     this.tablaProcedimientosToBe=[];
    this.tablaProcedimientos=[];
     this.tabs=['Procedimiento'];
     this.loadingGeneral=false;
     this.verDetallesProceso(parseInt(this.idIniciativa),0);
  }

  //Eliminar tabs
  removeTab(index: number) 
  {
    this.tabs.splice(index, 1);

  }//Cierre del método

 
  //Metodo para navegar entre los tabuladores
  navegarTab(form:number)
  {
    this.tabSeleccionado=form;
    //Limpiamos la tabla de procedimientos/arrays
    this.formProcesos.reset();
    this.tabla=[];
    this.tablaProcedimientosToBe=[];
    this.tablaProcedimientos=[];
      this.tabuladores.forEach((element, index) => {
       if(form==index)
       {
        this.dataService.detalleProceso(parseInt(this.idIniciativa),element).subscribe(data => {
          if (data['objData']['proceso']) 
          {
            let infoProceso: Proceso = data['objData']['proceso'];
            this.formProcesos.patchValue({
              id_proceso:infoProceso.id_proceso,
              nombre_proceso:infoProceso.nombre_proceso,
              procedimiento_proceso:infoProceso.procedimiento_proceso,
              duenio_proceso:infoProceso.duenio_proceso,
              tramitesExternosASIS_proceso:infoProceso.tramitesExternosASIS_proceso,
              tramitesExternosTOBE_proceso:infoProceso.tramitesExternosTOBE_proceso,
              tramitesInternosASIS_proceso:infoProceso.tramitesInternosASIS_proceso,
              tramitesInternosTOBE_proceso:infoProceso.tramitesInternosTOBE_proceso,
              hojasImpresasASIS_proceso:infoProceso.hojasImpresasASIS_proceso,
              hojasImpresasTOBE_proceso:infoProceso.hojasImpresasTOBE_proceso,
              kmRecorridosASIS_Proceso:infoProceso.kmRecorridosASIS_Proceso,
              kmRecorridosTOBE_Proceso:infoProceso.kmRecorridosTOBE_Proceso
            })
          }
    
          this.tabla=data['objData']['listDetalleProcesos'];
          //Llenamos los procedimientos
          if(data['objData']['listDetalleProcesos'])
          {
            for(let numero of this.tabla)
            {
              if(numero.tipoProceso_procesoDetalle==1)
              { 
                  this.tablaProcedimientosToBe.push(numero);
              }
              else{
                this.tablaProcedimientos.push(numero);
              }
            }
    
          }
           
        });
       }
      
      });
      
  }

  procesaPropagar(iniciativa) 
  {
    this.mostrarFormNuevo=true;
  }

  //Método para agregar iniciativa
  onSubmit() 
  {
    this.formarArrayImpacto();
    var myJSON = JSON.stringify(this.arrayImpactos);
    if(this.nuevoSisFormDatos.value==null)
    {
    }

    this.nuevoSisFormDatos.patchValue({
      fechaEnvio_iniciativa:moment(this.fechaActual).format('YYYY-MM-DD'),
      id_tipoIniciativa:1,
      id_estatusIniciativa:1,
      json_impacto:myJSON
    })
    //Enviar la data al service
   this.dataService.nuevoSistema(this.nuevoSisFormDatos.value).subscribe(
      data => {
        if (data['objData']) 
        {
          //Asigno el id de iniciativa
          this.idIniciativa=data['objData']['id_iniciativa'];
          //Verificamos si se agregaron archivos
          if(this.formArchivos.controls['docAnexos_iniciativas'].value)
          {
            this.subirArchivosRepositorios("anexos",parseInt(this.idIniciativa));
          }
          if(this.formArchivos.controls['doc_procesoPropuesto'].value){
            this.subirArchivosRepositorios("procesoPropuesto",parseInt(this.idIniciativa));
          }
          if(this.formArchivos.controls['doc_procesoActual'].value){
            this.subirArchivosRepositorios("procesoActual",parseInt(this.idIniciativa));
          }

            this.notifier.notify(
            'success',
            'Nueva iniciativa registrada correctamente.'
          );
          this.botonCosteo=true;
          this.nuevoSisFormDatos.patchValue({
            id_iniciativa:this.idIniciativa
          })

          this.formProcesos.patchValue({
            id_iniciativa:this.idIniciativa
          })
          //this.zone.run(() => this.router.navigate(['/mis-iniciativas']));
        }
        else{
        }
      },
      error => {
        this.notifier.notify(
          'error',
          'Ha ocurrido un error al intentar registrar la iniciativa. Verifique su conexión de red o contacte al administrador.'
        );
      }
    );
  }

  formarArrayImpacto()
  {
    if(this.inContibucionGobierno==true)
    {
      let val=this.nuevoSisFormDatos.controls['contribucionProgGobierno'].value;
      let contribucionProgGobierno={
        'id_iniciativa':this.nuevoSisFormDatos.controls['id_iniciativa'].value,
        'id_impacto':1,
        'detalle_iniciativaImpacto':val
      }
      this.arrayImpactos.push(contribucionProgGobierno);
    }

    if(this.inContibucionOperativo==true)
    {
      let val=this.nuevoSisFormDatos.controls['contribucionProgOperativo'].value;
      let contribucionProgOperativo={
        'id_iniciativa':this.nuevoSisFormDatos.controls['id_iniciativa'].value,
        'id_impacto':2,
        'detalle_iniciativaImpacto':val
      }
      this.arrayImpactos.push(contribucionProgOperativo);
    }

    if(this.inImpactoProcesos==true)
    {
      let val=this.nuevoSisFormDatos.controls['impactoProcesos'].value;

      let impactoProcesos={
        'id_iniciativa':this.nuevoSisFormDatos.controls['id_iniciativa'].value,
        'id_impacto':3,
        'detalle_iniciativaImpacto':val
      }
      this.arrayImpactos.push(impactoProcesos);
    }

    if(this.inMejorarServicioCiudadania==true)
    {
      let val=this.nuevoSisFormDatos.controls['mejoraServicio'].value;

      let mejoraServicio={
        'id_iniciativa':this.nuevoSisFormDatos.controls['id_iniciativa'].value,
        'id_impacto':4,
        'detalle_iniciativaImpacto':val
      }
      this.arrayImpactos.push(mejoraServicio);
    }

    if(this.inCumplimientoLey==true)
    {
      let val=this.nuevoSisFormDatos.controls['cumplimientoLey'].value;
      let cumplimientoLey={
        'id_iniciativa':this.nuevoSisFormDatos.controls['id_iniciativa'].value,
        'id_impacto':5,
        'detalle_iniciativaImpacto':val
      }
      this.arrayImpactos.push(cumplimientoLey);
    }

    if(this.inModernizacionDependencia==true)
    {
      let val=this.nuevoSisFormDatos.controls['contribucionModernizacion'].value;
      let contribucionModernizacion={
        'id_iniciativa':this.nuevoSisFormDatos.controls['id_iniciativa'].value,
        'id_impacto':6,
        'detalle_iniciativaImpacto':val
      }
      this.arrayImpactos.push(contribucionModernizacion);
    }

  }
  

  formarArrayImpactoEdit()
  {
    if(this.inContibucionGobierno==true)
    {
      let val=this.nuevoSisFormDatos.controls['contribucionProgGobierno'].value;
      let contribucionProgGobierno={
        'id_iniciativa':this.nuevoSisFormDatos.controls['id_iniciativa'].value,
        'id_impacto':1,
        'detalle_iniciativaImpacto':val
      }
      this.arrayImpactos.push(contribucionProgGobierno);
    }

    if(this.inContibucionOperativo==true)
    {
      let val=this.nuevoSisFormDatos.controls['contribucionProgOperativo'].value;
      let contribucionProgOperativo={
        'id_iniciativa':this.nuevoSisFormDatos.controls['id_iniciativa'].value,
        'id_impacto':2,
        'detalle_iniciativaImpacto':val
      }
      this.arrayImpactos.push(contribucionProgOperativo);
    }

    if(this.inImpactoProcesos==true)
    {
      let val=this.nuevoSisFormDatos.controls['impactoProcesos'].value;
      let impactoProcesos={
        'id_iniciativa':this.nuevoSisFormDatos.controls['id_iniciativa'].value,
        'id_impacto':3,
        'detalle_iniciativaImpacto':val
      }
      this.arrayImpactos.push(impactoProcesos);
    }

    if(this.inMejorarServicioCiudadania==true)
    {
      let val=this.nuevoSisFormDatos.controls['mejoraServicio'].value;
      let mejoraServicio={
        'id_iniciativa':this.nuevoSisFormDatos.controls['id_iniciativa'].value,
        'id_impacto':4,
        'detalle_iniciativaImpacto':val
      }
      this.arrayImpactos.push(mejoraServicio);
    }

    if(this.inCumplimientoLey==true)
    {
      let val=this.nuevoSisFormDatos.controls['cumplimientoLey'].value;
      let cumplimientoLey={
        'id_iniciativa':this.nuevoSisFormDatos.controls['id_iniciativa'].value,
        'id_impacto':5,
        'detalle_iniciativaImpacto':val
      }
      this.arrayImpactos.push(cumplimientoLey);
    }

    if(this.inModernizacionDependencia==true)
    {
      let val=this.nuevoSisFormDatos.controls['contribucionModernizacion'].value;
      let contribucionModernizacion={
        'id_iniciativa':this.nuevoSisFormDatos.controls['id_iniciativa'].value,
        'id_impacto':6,
        'detalle_iniciativaImpacto':val
      }
      this.arrayImpactos.push(contribucionModernizacion);
    }

  }

  onFileChange(event: any, nombreArchivo: string) 
  {
    if (event.target.files && event.target.files.length) 
    {
      const [file] = event.target.files;

      switch (nombreArchivo) 
      {
        case 'procesoActual':
          this.procesoActualError = false;
          this.archivoActual=file;
          this.labelProcesoActual.nativeElement.innerText = file.name;
          let extensionActual;
          //Si es documento
          if(file.type.indexOf("pdf")!==-1)
          {
              extensionActual = file.type.split('/');
              if(extensionActual[1]==="pdf")
              {
                 // this.subiendoProcesoActual = true;
                   this.formArchivos.patchValue({
                    doc_procesoActual: nombreArchivo+'.'+extensionActual[1]
                  });
               }
               //Si no es PDF
             else{
              this.procesoActualError = false;
              this.labelProcesoActual.nativeElement.innerText = "";
              this.notifier.notify('error','Formato de archivo no permitido.');
             }
          }
          //Si no es archivo
          else{
            this.subiendoProcesoActual=false;
            this.labelProcesoActual.nativeElement.innerText = "";
            this.notifier.notify('error','Formato de archivo no permitido.');

        }



          
          /*this.dataService.subirArchivos(file, nombreArchivo,parseInt(this.idIniciativa)).subscribe( 
            (data: string) => {
              if (data) {
                this.nuevoSisFormDatos.patchValue({
                  procesoActual: data,
                  doc_procesoActual:data['objData']
                });
              }
              this.subiendoProcesoActual = false;
            },
            error => {
              console.error(error);
              this.procesoActualError = true;
              this.procesoActualInput.nativeElement.value = '';
              this.subiendoProcesoActual = false;
            }
          );*/
          break;
        case 'procesoPropuesto':
          this.procesoPropuestoError = false;
          this.archivoPropuesto=file;
          this.labelProcesoPropuesto.nativeElement.innerText = file.name;
          let extensionPropuesto;

          //Si es documento
          if(file.type.indexOf("pdf")!==-1)
          {
            extensionPropuesto= file.type.split('/');
            if(extensionPropuesto[1]==="pdf")
              {
                   //this.subiendoProcesoPropuesto = true;
                  this.formArchivos.patchValue({
                    doc_procesoPropuesto: nombreArchivo+'.'+extensionPropuesto[1],
                  });

               }
               //Si no es PDF
             else{
              this.subiendoProcesoPropuesto = false;
              this.labelProcesoPropuesto.nativeElement.innerText="";
              this.notifier.notify('error','Formato de archivo no permitido.');
             }

          }
          //Si no es archivo
          else{
            this.subiendoProcesoPropuesto=false;
            this.labelProcesoPropuesto.nativeElement.innerText="";
            this.notifier.notify('error','Formato de archivo no permitido.');
        }
          /*this.dataService.subirArchivos(file, nombreArchivo,parseInt(this.idIniciativa)).subscribe(
            (data: string) => {
              if (data) {
                this.nuevoSisFormDatos.patchValue({
                  procesoPropuesto: data,
                  doc_procesoPropuesto:data['objData']
                });
              }
              this.subiendoProcesoPropuesto = false;
            },
            error => {
              console.error(error);
              this.procesoPropuestoError = true;
              this.procesoPropuestoInput.nativeElement.value = '';
              this.subiendoProcesoPropuesto = false;
            }
          );*/
          break;
        case 'anexos':
          this.otrosArchivosError = false;
          this.archivoAnexo=file;
          this.labelAnexos.nativeElement.innerText = file.name;
          let extensionAnexo=[];
          //Si es archivo
          if(file.type)
          {
            extensionAnexo= file.type.split('/');
            switch (file.type)
            {
              case "application/zip":
                //this.subiendoOtrosArchivos=true;
                extensionAnexo[1]="zip";
                break;
              case "application/pdf":
                //this.subiendoOtrosArchivos=true;
              break;
              case "application/x-zip-compressed":
                //this.subiendoOtrosArchivos=true;
                extensionAnexo[1]="zip";
              break;
              case "application/octet-stream":
                //this.subiendoOtrosArchivos=true;
                extensionAnexo[1]="zip";
              break;
              case "application/x-rar-compressed":
                //this.subiendoOtrosArchivos=true;
                extensionAnexo[1]="rar";
              break;
              default:
                //this.subiendoOtrosArchivos=false;
                this.labelAnexos.nativeElement.innerText="";
                this.notifier.notify('error','Formato de archivo no permitido.');
                break;
            }



            /*
            extensionAnexo= file.type.split('/');
            //this.subiendoOtrosArchivos = true;
              if(extensionAnexo[1]==="pdf" || extensionAnexo[1].indexOf("zip")===0)
              {
                this.subiendoOtrosArchivos=true;
                if(extensionAnexo[1].indexOf("zip")==0)
                {
                  extensionAnexo[1]=="zip";
                }
              
             }
             else{
               //this.otrosArchivosError=true;
              this.subiendoOtrosArchivos=false;
              this.labelAnexos.nativeElement.innerText="";
              this.notifier.notify('error','Formato de archivo no permitido');
             }*/
          }
          else{
            //Si es carpeta
             extensionAnexo = file.name.split('.');
             if(extensionAnexo[extensionAnexo.length-1]==="rar")
             {
              //this.subiendoOtrosArchivos = true;
              
             }
             else{
              //this.subiendoOtrosArchivos=false;
              this.labelAnexos.nativeElement.innerText="";
              this.notifier.notify('error','Formato de archivo no permitido');
             }
          }
          this.formArchivos.patchValue({
            docAnexos_iniciativas: nombreArchivo+'.'+extensionAnexo[extensionAnexo.length-1],
          });
          
          /*this.dataService.subirArchivos(file, nombreArchivo,parseInt(this.idIniciativa)).subscribe(
            (data: string) => {
              if (data) {
                this.nuevoSisFormDatos.patchValue({
                  otrosArchivos: data,
                  docAnexos_iniciativas:data['objData']
                  
                });
              }
              this.subiendoOtrosArchivos = false;
            },
            error => {
              console.error(error);
              this.otrosArchivosError = true;
              this.otrosArchivosInput.nativeElement.value = '';
              this.subiendoOtrosArchivos = false;
            }
          );*/
          break;
        default:
          break;
      }
    }
  }

  /*Método para los combos de areas del solicitante
  onChangeArea(areaGral: string) 
  {
    this.areaGralSeleccionada = areaGral;
    this.dataService.obtenerAreaSolicitante(areaGral).subscribe(
      data => {
        if (data['data']) {
          this.direccionesArea = data['data'];
        }
      },
      error => {
      }
    );
  }*/

  
  //Método para guardar los acrhivos en el repositorio
  subirArchivosRepositorios(nombreArchivo:string,id:number,)
  {
    switch (nombreArchivo) 
      {
        case 'procesoActual':
          this.subiendoProcesoActual = false;
          this.procesoActualError = false;
          this.dataService.subirArchivos(this.archivoActual, nombreArchivo,parseInt(this.idIniciativa)).subscribe( 
            (data: string) => {
              if (data['alert']==0) 
              {
                //Modificamos el nombre del archivo
                let valores={
                  id_iniciativa:this.idIniciativa,
                  doc_procesoActual:data['objData']
                }
                this.dataService.updateArchivoProcesoActual(valores).subscribe(
                  data =>{
                    this.subiendoProcesoActual = true;
                    this.archivoProcesoActualRequerido=false;
                  }
                );

              }
              else{
                this.procesoActualError=true;
                this.subiendoProcesoActual = false;
              }
            },
            error => {
              console.error(error);
              this.procesoActualError = true;
              this.procesoActualInput.nativeElement.value = '';
              this.subiendoProcesoActual = false;
            }
          );
          break;
        case 'procesoPropuesto':
          this.subiendoProcesoPropuesto = false;
          this.procesoPropuestoError = false;
          this.dataService.subirArchivos(this.archivoPropuesto, nombreArchivo,parseInt(this.idIniciativa)).subscribe(
            (data: string) => {
              if (data['alert']==0) 
              {
                //Modificamos el nombre del archivo
                let valores={
                  id_iniciativa:this.idIniciativa,
                  doc_procesoPropuesto:data['objData']
                }
                this.dataService.updateArchivoProcesoPropuesto(valores).subscribe(
                  data =>{
                    this.archivoProcesoPropuesto=false;
                    this.subiendoProcesoPropuesto = true;
                  }
                );

              }    
              else{
                this.procesoPropuestoError=true;
                this.subiendoProcesoPropuesto = false;
              }          
              //this.subiendoProcesoPropuesto = false;
            },
            error => {
              console.error(error);
              this.procesoPropuestoError = true;
              this.procesoPropuestoInput.nativeElement.value = '';
              this.subiendoProcesoPropuesto = false;
            }
          );
          break;
        case 'anexos':
          //this.subiendoOtrosArchivos = true;
          //this.otrosArchivosError = false;
          this.dataService.subirArchivos(this.archivoAnexo, nombreArchivo,parseInt(this.idIniciativa)).subscribe(
            (data: string) => {
              if (data['alert']==0) 
              {
                let valores={
                  id_iniciativa:this.idIniciativa,
                  docAnexos_iniciativas:data['objData']
                }
                this.dataService.updateArchivoAnexos(valores).subscribe(
                  data =>{
                    this.subiendoOtrosArchivos = true;
                  }
                );
              }
              else{
                this.otrosArchivosError = true;
                this.subiendoOtrosArchivos = false;

              }
              
            },
            error => {
              console.error(error);
              this.otrosArchivosError = true;
              this.otrosArchivosInput.nativeElement.value = '';
              this.subiendoOtrosArchivos = false;
            }
          );
          break;
        default:
          break;
      }
  }

  limpiarCampoImpacto(impacto: number) 
  {
    switch (impacto) {
      case 1:
        this.nuevoSisFormDatos.get('contribucionProgGobierno').reset();
        break;
      case 2:
        this.nuevoSisFormDatos.get('contribucionProgOperativo').reset();
        break;
      case 3:
        this.nuevoSisFormDatos.get('impactoProcesos').reset();
        break;
      case 4:
        this.nuevoSisFormDatos.get('mejoraServicio').reset();
        break;
      case 5:
        this.nuevoSisFormDatos.get('cumplimientoLey').reset();
        break;
      case 6:
        this.nuevoSisFormDatos.get('contribucionModernizacion').reset();
        break;
    }
  }

  checar(id): boolean {
    return this.selected.includes(id);
  }

  activarInsertar()
  {
    if(this.nuevoSisFormDatos.controls.doc_procesoActual.value)
    {
      this.mostrardescargarArchivoPA=true;
      this.nombreArchivoPA=this.nuevoSisFormDatos.controls.doc_procesoActual.value;
    }
    if(this.nuevoSisFormDatos.controls.doc_procesoPropuesto.value)
    {
      this.mostrardescargarArchivoPP=true;
      this.nombreArchivoPP=this.nuevoSisFormDatos.controls.doc_procesoPropuesto.value;

    }
    if(this.nuevoSisFormDatos.controls.docAnexos_iniciativas.value)
    {
      this.mostrardescargarArchivoAN=true;
      this.nombreArchivoAN=this.nuevoSisFormDatos.controls.docAnexos_iniciativas.value;
    }
    this.mostrarFormNuevo=true;
   
  }


  activarModificar()
  {
    if(this.nuevoSisFormDatos.controls.doc_procesoActual.value)
    {
      this.mostrardescargarArchivoPA=true;
      this.nombreArchivoPA=this.nuevoSisFormDatos.controls.doc_procesoActual.value;
    }
    if(this.nuevoSisFormDatos.controls.doc_procesoPropuesto.value)
    {
      this.mostrardescargarArchivoPP=true;
      this.nombreArchivoPP=this.nuevoSisFormDatos.controls.doc_procesoPropuesto.value;

    }
    if(this.nuevoSisFormDatos.controls.docAnexos_iniciativas.value)
    {
      this.mostrardescargarArchivoAN=true;
      this.nombreArchivoAN=this.nuevoSisFormDatos.controls.docAnexos_iniciativas.value;
    }
    this.mostrarFormEditar=true;
   
  }

  //Método para recuperar los datos del costeo
  verDetallesProceso(id_iniciativa:number, id_proceso:number)
  {
    this.dataService.detalleProceso(id_iniciativa,id_proceso).subscribe(data => {
      if (data['objData']['proceso']) 
      {
        let infoProceso: Proceso = data['objData']['proceso'];
        this.formProcesos.patchValue({
          id_proceso:infoProceso.id_proceso,
          nombre_proceso:infoProceso.nombre_proceso,
          procedimiento_proceso:infoProceso.procedimiento_proceso,
          duenio_proceso:infoProceso.duenio_proceso,
          tramitesExternosASIS_proceso:infoProceso.tramitesExternosASIS_proceso,
          tramitesExternosTOBE_proceso:infoProceso.tramitesExternosTOBE_proceso,
          tramitesInternosASIS_proceso:infoProceso.tramitesInternosASIS_proceso,
          tramitesInternosTOBE_proceso:infoProceso.tramitesInternosTOBE_proceso,
          hojasImpresasASIS_proceso:infoProceso.hojasImpresasASIS_proceso,
          hojasImpresasTOBE_proceso:infoProceso.hojasImpresasTOBE_proceso,
          kmRecorridosASIS_Proceso:infoProceso.kmRecorridosASIS_Proceso,
          kmRecorridosTOBE_Proceso:infoProceso.kmRecorridosTOBE_Proceso
        })
      }      
      this.tabla=data['objData']['listDetalleProcesos'];
      //Llenamos los procedimientos
      if(data['objData']['listDetalleProcesos'])
      {
        for(let numero of this.tabla)
        {
          if(numero.tipoProceso_procesoDetalle==1)
          { 
              this.tablaProcedimientosToBe.push(numero);
          }
          else{
            this.tablaProcedimientos.push(numero);
          }
        }

      }
       
      this.tabuladores=data['objData']['listIdProceso'];
      /*this.tabuladores.forEach((element, index) => {
        this.tabs.push(`Procedimiento ${this.tabs.length + 1}`);
      });*/
      //Generamos los tabuladores necesarios
      for(let numero of this.tabuladores)
      {
        this.tabs.push(`Procedimiento ${this.tabs.length + 1}`); 
      }
      //Eliminamos el ultimo tap cuando la iniciativa trae procesos 
      if(this.tabuladores.length!=0)
      {
        this.removeTab(this.tabs.length-1);
      }
  });
}


  //Método para abrir el componente del costeo
  abrirCosteo()
  {
    this.mostrarFormNuevo=false;
    this.mostrarFormEditar=false;
    this.mostrarCosteo=true;
    //this.botonSiguiente.emit(parseInt(this.idIniciativa));
    //this.router.navigate(['./costeo'])
  }

  verDetallesIniciativa(id: number) 
  {
    this.dataService.detalleIniciativa(id).subscribe(data => {
      if (data['objData']) 
      {
        this.idProceso=data['objData']['id_proceso'];
        //this.iniciativaSeleccionada = data['objData'];
        let infoiniciativa: Iniciativa = data['objData'];
        this.nameDirGral=data['objData']['nombre_dirgralSapSolicitante'];
        if(infoiniciativa.doc_procesoActual)
        {
          this.mostrardescargarArchivoPA=true;
          this.nombreArchivoPA=infoiniciativa.doc_procesoActual;
        }
        if(infoiniciativa.doc_procesoPropuesto)
        {
          this.mostrardescargarArchivoPP=true;
          this.nombreArchivoPP=infoiniciativa.doc_procesoPropuesto;
        }
        if(infoiniciativa.docAnexos_iniciativas)
        {
          this.mostrardescargarArchivoAN=true;
          this.nombreArchivoAN=infoiniciativa.docAnexos_iniciativas;
        }

        if(infoiniciativa.fechaTermino_iniciativa){
          this.fechaTermino=moment(infoiniciativa.fechaTermino_iniciativa).format('YYYY-MM-DD');
       }

        this.nuevoSisFormDatos.patchValue({
          id_iniciativa:infoiniciativa.id_iniciativa,
          nombre_iniciativa:infoiniciativa.nombre_iniciativa,
          nombre_solicitante:infoiniciativa.nombre_solicitante,
          email_solicitante:infoiniciativa.email_solicitante,
          direccionArea_solicitante:infoiniciativa.direccionArea_solicitante,
          telefono_solicitante:infoiniciativa.telefono_solicitante,
          extencion_solicitante:infoiniciativa.extencion_solicitante,
          problematica_iniciativa:infoiniciativa.problematica_iniciativa,
          fechaTermino_iniciativa:this.fechaTermino,
          //fechaTermino_iniciativa:moment(infoiniciativa.fechaTermino_iniciativa).format('YYYY-MM-DD'),
          justificacionFecha_iniciativa:infoiniciativa.justificacionFecha_iniciativa,
          numeroTransacciones_iniciativa:infoiniciativa.numeroTransacciones_Iniciativa,
          solucionPropuesta_iniciativa:infoiniciativa.solucionPropuesta_iniciativa,
          beneficiariosDirectos_iniciativa:infoiniciativa.beneficiariosDirectos_iniciativa,
          beneficiariosImplementacion_iniciativa:infoiniciativa.beneficiariosImplementacion_iniciativa,
          doc_procesoActual:infoiniciativa.doc_procesoActual,
          doc_procesoPropuesto:infoiniciativa.doc_procesoPropuesto,
          docAnexos_iniciativas:infoiniciativa.docAnexos_iniciativas,
          id_proceso:infoiniciativa.id_proceso,
          id_estatusIniciativa:infoiniciativa.id_estatusIniciativa,
          id_tipoIniciativa:infoiniciativa.id_tipoIniciativa,
          fechaEnvio_iniciativa:infoiniciativa.fechaEnvio_iniciativa,
          dirGral_solicitante: infoiniciativa.dirGral_solicitante,
          nombreProceso_iniciativa:infoiniciativa.nombreProceso_iniciativa,
          id_dirgralSapSolicitante: infoiniciativa.id_dirgralSapSolicitante,
          id_areaSapSolicitante: infoiniciativa.id_areaSapSolicitante,
        });

        //Volvemos a cargar las areas 
            if(infoiniciativa.id_dirgralSapSolicitante)
            {
              this.dataService.obtenerAreaSolicitante(infoiniciativa.id_dirgralSapSolicitante).subscribe(
              data => {
                if (data['data']) {
                  this.direccionesArea = data['data'];
                }
              },
              error => {
                console.log(error);
              }
            );
          }
        //this.iniciativaSeleccionada.tipoIniciativa = tipoIniciativa;
        const tempImpactos = data['objData'].jsonIniciativaImpacto;
        //this.iniciativaSeleccionada.impactos = [];
        if (tempImpactos) 
        {
          tempImpactos.split('|').forEach((element) => {
            let j:Impactos[]=JSON.parse(element)
            this.arrayImpactosConsulta=j;
            this.formarImpactos(j);
          });
        }

        //if(this.nuevoSisFormDatos.controls.id_proceso.value)
        //{
          this.botonEnviar=true;
          //Obtenemos los datos del costeo
          this.verDetallesProceso(id,0);
          //this.recargarTabla(this.nuevoSisFormDatos.controls.id_proceso.value);
        //}
            
      }
    });
  }

  editarIniciativa(form:any)
  {
    //Limpiamos el array de impactos
    this.arrayImpactos=[];
    this.formarArrayImpactoEdit();
    var myJSON = JSON.stringify(this.arrayImpactos);
    form.userlogin=this.emailUser;
    form.rolUserlogin=this.idRolSeleccionado;
    form.json_impacto=myJSON;
    
   if(this.formArchivos.controls['docAnexos_iniciativas'].value)
    {
      form.docAnexos_iniciativas=this.formArchivos.controls['docAnexos_iniciativas'].value;
    }
    if(this.formArchivos.controls['doc_procesoPropuesto'].value){
      form.doc_procesoPropuesto=this.formArchivos.controls['doc_procesoPropuesto'].value;
    }
    if(this.formArchivos.controls['doc_procesoActual'].value){
      form.doc_procesoActual=this.formArchivos.controls['doc_procesoActual'].value;
    }

    this.dataService.editarNuevoSistema(form).subscribe(
      data => {
        if (data['objData']) 
        {
          //Asigno el id de iniciativa
          this.idIniciativa=form.id_iniciativa;
          //this.idIniciativa=data['objData']['id_iniciativa'];
          //Verificamos si se agregaron archivos
          /*if(this.nuevoSisFormDatos.controls['docAnexos_iniciativas'].value && this.archivoAnexo)
          {
            this.subirArchivosRepositorios("anexos",parseInt(this.idIniciativa));
          }
          if(this.nuevoSisFormDatos.controls['doc_procesoPropuesto'].value && this.archivoPropuesto)
          {
            this.subirArchivosRepositorios("procesoPropuesto",parseInt(this.idIniciativa));
          }
          if(this.nuevoSisFormDatos.controls['doc_procesoActual'].value && this.archivoActual)
          {
            this.subirArchivosRepositorios("procesoActual",parseInt(this.idIniciativa));
          }*/


          if(this.formArchivos.controls['docAnexos_iniciativas'].value)
          {
            this.subirArchivosRepositorios("anexos",parseInt(this.idIniciativa));
          }
          if(this.formArchivos.controls['doc_procesoPropuesto'].value){
            this.subirArchivosRepositorios("procesoPropuesto",parseInt(this.idIniciativa));
          }
          if(this.formArchivos.controls['doc_procesoActual'].value){
            this.subirArchivosRepositorios("procesoActual",parseInt(this.idIniciativa));
          }
          this.notifier.notify(
            'success',
            'Iniciativa editada correctamente.'
          );
          this.botonCosteo=true;
          this.formProcesos.patchValue({
            id_iniciativa:form.id_iniciativa,
            id_proceso:form.id_proceso
          })
          //this.zone.run(() => this.router.navigate(['/mis-iniciativas']));
        }
        else{
        }
      },
      error => {
        console.error(error);
        this.notifier.notify(
          'error',
          'Ha ocurrido un error al intentar registrar la iniciativa. Verifique su conexión de red o contacte al administrador.'
        );
      }
    );
  }


  formarImpactos(impactosArray:Impactos[]) 
  {
    for(let i in impactosArray)
    {
      let impacto=impactosArray[i].id_impacto;
      switch (impacto) 
      {
        case 1:
          //this.checkSeleccionado=true;
          this.inContibucionGobierno=true;
          this.nuevoSisFormDatos.patchValue({
          contribucionProgGobierno:impactosArray[i].detalle_iniciativaImpacto
          })
          break;
        case 2:
          this.inContibucionOperativo=true;
          this.nuevoSisFormDatos.patchValue({
            contribucionProgOperativo:impactosArray[i].detalle_iniciativaImpacto
          })
          break;
        case 3:
          this.checkSeleccionado=true;
          this.inImpactoProcesos=true;
          this.nuevoSisFormDatos.patchValue({
            impactoProcesos:impactosArray[i].detalle_iniciativaImpacto
          })
          break;
        case 4:
          //this.checkSeleccionado=true;
          this.inMejorarServicioCiudadania=true;
          this.nuevoSisFormDatos.patchValue({
            mejoraServicio:impactosArray[i].detalle_iniciativaImpacto
          })
          break;
        case 5:
          //this.checkSeleccionado=true;
          this.inCumplimientoLey=true;
          this.nuevoSisFormDatos.patchValue({
            cumplimientoLey:impactosArray[i].detalle_iniciativaImpacto
          })
          break;
        case 6:
          //this.checkSeleccionado=true;
          this.inModernizacionDependencia=true;
          this.nuevoSisFormDatos.patchValue({
            contribucionModernizacion:impactosArray[i].detalle_iniciativaImpacto
          })
          break;
      }
   }
}


  //Método para descargar archivos
  descargarArchivo(archivo:string)
  {
    this.dataService.descargarArchivo(parseInt(this.idIniciativa),archivo).subscribe(res => {
      // Este es necesario para crear un objeto blob con el tipo de archivo
      // puesto explicitamente, de lo contrario solo Chrome funcionara correctamente
      let newBlob = new Blob([res], { type: this.obtenerTipoArchivo(archivo) });
      // IE no permite objetos blob directamente en el atributo href de un link
      // en su lugar hay que usar msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }
      const data = window.URL.createObjectURL(newBlob);
       let link = document.createElement('a');
      link.href = data;
      link.download = archivo;
      // Esta linea es necesaria desde que link.click() ya no funciona en las ultimas versiones de firefox
      link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

      setTimeout(function () {
        // Para Firefox es necesario retrasar la revocacion del objeto ObjectURL
        window.URL.revokeObjectURL(data);
        link.remove();
      }, 100);

    });

  }


  private obtenerTipoArchivo(archivo: string): string {
    let tipoArchivo: string;
    let extencion: string = archivo.split('.').pop();

    switch (extencion) {
      case 'pdf':
        tipoArchivo = 'application/pdf';
        break;
      case 'xls':
        tipoArchivo = 'application/vnd.ms-excel';
        break;
      case 'xlsx':
        tipoArchivo = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        break;
      case 'csv':
        tipoArchivo = 'application/csv';
        break;
      case 'zip':
        tipoArchivo = 'application/zip';
        break;
      case 'rar':
        tipoArchivo = 'application/x-rar-compressed';
        break;

      default:
        tipoArchivo = 'text/plain';
        break;
    }
    return tipoArchivo;
  }


  cancelar()
  {
    this.mostrarFormConsultar==false;
    //this.nuevoSisFormDatos.reset();
    this.router.navigate(['./mis-iniciativas'])
  }

  //Abrir modal para agregar los procedimientos del proceso ASIS
 abrirModalCosteoConsulta()
 { 
   const dialogRef = this.dialog.open(ModalCosteoConsultaComponent,{data:{id_iniciativa:this.idIniciativa,id_proceso:this.idProceso},disableClose:false, height: '580px',
   width: '800px'});
   dialogRef.afterClosed().subscribe(data => {
     if(data==false)
     {
       console.log("Error");
     }
     else{
       //Mapeamos el idProceso y tipo
       //Recargamos la tabla
       //this.recargarTabla(this.id_proceso);
     }//Cerrar el else
   //Cerrar ventana modal
  });
}

enviarIniciativa(form:any)
{
    this.dataService.enviarIniciativa(form.id_iniciativa,this.emailUser,this.idRolSeleccionado).subscribe( 
      data => {
        if (data['alert']==0)
        {
          this.notifier.notify('success', 'Iniciativa enviada correctamente Folio:'+ data['objData']);
          this.zone.run(() => this.router.navigate(['/mis-iniciativas']));
          //this.notifier.notify('success', 'Nueva iniciativa para cambios en funcionalidades editada correctamente.');
        }
        else{
          this.validacionCondicional(form);
          this.notifier.notify('error',data['errorMessage']);
        }
      },
      error => {
        console.error(error);
      }
    );
}

private validacionCondicional(form:any) 
{
  this.archivoProcesoActualRequerido = false;
  this.archivoProcesoPropuesto = false;
  this.nuevoSisFormDatos = this._formBuilder.group({
    id_iniciativa: [form.id_iniciativa],
    id_proceso: [form.id_proceso],
    folio_iniciativa:[form.folio_iniciativa],
    fechaEnvio_iniciativa:[form.fechaEnvio_iniciativa],
    id_tipoIniciativa: [form.id_tipoIniciativa],
    id_area : [form.id_area],
    id_aplicativo: [form.id_aplicativo],
    id_estatusIniciativa: [form.id_estatusIniciativa],

    nombre_iniciativa: [form.nombre_iniciativa, Validators.required],
    nombre_solicitante: [form.nombre_solicitante, Validators.required],
    email_solicitante: [form.email_solicitante, Validators.required],
    telefono_solicitante: [form.telefono_solicitante, Validators.required],
    extencion_solicitante: [form.extencion_solicitante],
    fechaTermino_iniciativa: [form.fechaTermino_iniciativa, Validators.required],
    justificacionFecha_iniciativa: [form.justificacionFecha_iniciativa, Validators.required],
    numeroTransacciones_iniciativa: [form.numeroTransacciones_iniciativa, Validators.required],    
    solucionPropuesta_iniciativa: [form.solucionPropuesta_iniciativa, Validators.required],
    beneficiariosDirectos_iniciativa: [form.beneficiariosDirectos_iniciativa, Validators.required],
    beneficiariosImplementacion_iniciativa:[form.beneficiariosImplementacion_iniciativa, Validators.required],
    nombreProceso_iniciativa: [form.nombreProceso_iniciativa, Validators.required],
    doc_procesoActual: [form.doc_procesoActual, Validators.required],
    doc_procesoPropuesto: [form.doc_procesoPropuesto, Validators.required],
    docAnexos_iniciativas: [form.docAnexos_iniciativas, Validators.required],
    problematica_iniciativa: [form.problematica_iniciativa, Validators.required],
    id_dirgralSapSolicitante:[form.id_dirgralSapSolicitante, Validators.required],
    id_areaSapSolicitante:[form.id_areaSapSolicitante, Validators.required],
    //dirGral_solicitante:[form.dirGral_solicitante, Validators.required],
    //direccionArea_solicitante: [form.direccionArea_solicitante, Validators.required],

    json_impactoimp: new FormGroup(
      {},
        almenosUnImpactoValidator()
      ),
   
    //Impactos
    contribucionProgGobierno: [form.contribucionProgGobierno],
    contribucionProgOperativo: [form.contribucionProgOperativo],
    impactoProcesos: [form.impactoProcesos],
    mejoraServicio: [form.mejoraServicio],
    cumplimientoLey:[form.cumplimientoLey],
    contribucionModernizacion: [form.contribucionModernizacion],
  });
     const tempImpactos = form.json_impacto;
        if (tempImpactos) 
        {
          tempImpactos.split('|').forEach((element) => {
            let j:Impactos[]=JSON.parse(element)
            this.arrayImpactosConsulta=j;
            this.formarImpactos(j);
          });
        }
        else{}


        if(!this.formArchivos.controls['doc_procesoActual'].value)
        {
          this.archivoProcesoActualRequerido = true;
        }
        if(!this.formArchivos.controls['doc_procesoPropuesto'].value)
        {
            this.archivoProcesoPropuesto = true;
        } 

        /*Si se edita
      if(this.mostrarFormEditar)
      {
        if(!form.doc_procesoPropuesto)
          {
            this.archivoProcesoActualRequerido = true;
          }
          if(!form.doc_procesoPropuesto)
          {
            this.archivoProcesoPropuesto = true;
          }

      }
      //Agregar
      else
      {
        if(!this.formArchivos.controls['doc_procesoActual'].value)
        {
          this.archivoProcesoActualRequerido = true;
        }
        if(!this.formArchivos.controls['doc_procesoPropuesto'].value)
        {
            this.archivoProcesoPropuesto = true;
        } 

    }*/
  
}

//Método para guardar/modificar proceso
guardarCosteo(form:any)
{
  //Mapeamos el id de la iniciativa
  form.id_iniciativa=this.idIniciativa;
  //Agregamos los valores de la lista de procedimientosToBe a la lista de procedimientos
  if(this.tablaProcedimientosToBe.length >= 1)
  {
    for(let numero of this.tablaProcedimientosToBe)
    {
        this.tablaProcedimientos.push(numero);
    }
  }
  this.dataService.insertarUpdateProceso(this.formProcesos.value,this.tablaProcedimientos).subscribe(res=>{
    if (res['errorMessage']) 
    {
      this.notifier.notify('error',
      'Ha ocurrido un error al intentar guardar el costeo. Revisa tu conexión de red en inténtalo de nuevo más tarde.');
    } 
    else{
        //Mapeamos el proceso
        this.idProceso=res['objData']['proceso']['id_proceso'];
        this.notifier.notify('success', 'Costeo de iniciativa registrado correctamente.');
        this.tabuladores=res['objData']['listIdProceso'];
        //Recargamos el tab modificado
        this.navegarTab(this.tabSeleccionado);
        this.botonEnviar=true;
          //this.zone.run(() => this.router.navigate(['/mis-iniciativas']));
      }
  });
}

 //Abrir modal para agregar los procedimientos del proceso ASIS
 abrirModalProcedimientoAsIs()
 { 
   const dialogRef = this.dialog.open(ModalProcedimientoComponent,{data:{titulo:`Procedimiento Actual (As-Is)`},disableClose:true, height: '580px',
   width: '800px'});
   dialogRef.afterClosed().subscribe(data => {
     if(data==false)
     {
     }
     else{
       //Mapeamos el idProceso y tipo
       data['id_proceso']=this.formProcesos.controls.id_proceso.value;
       data['tipoProceso_procesoDetalle']=0;
       this.tablaProcedimientos.push(data);
       //Recargamos la tabla
       //this.recargarTabla(this.id_proceso);
     }//Cerrar el else
   //Cerrar ventana modal
  });
}


 //Abrir modal para agregar los procedimientos del proceso ASIS
 abrirModalProcedimientoToBe()
 { 
   const dialogRef = this.dialog.open(ModalProcedimientoComponent,{data:{titulo:`Procedimiento Propuesto (To-Be)`},disableClose:true, height: '580px',
   width: '800px'});
   dialogRef.afterClosed().subscribe(data => {
     if(data==false)
     {
     }
     else{
       //Mapeamos el idProceso y tipo
       data['id_proceso']=this.formProcesos.controls.id_proceso.value;
       data['tipoProceso_procesoDetalle']=1;
       this.tablaProcedimientosToBe.push(data);
       //Recargamos la tabla
       //this.recargarTabla(this.id_proceso);
     }//Cerrar el else
   //Cerrar ventana modal
  });
}

//Método para editar el modal del proceso AsIs
editarProcedimientoAsIs(id:number)
{
  //Convertimos el valor de la tabla en una cadena JSON y la enviamos al modal
  let cadena=JSON.stringify(this.tablaProcedimientos[id]);
  const dialogRef = this.dialog.open(ModalProcedimientoComponent,{data:{data:`${cadena}`, titulo:`Procedimiento Actual (As-Is)`},disableClose:true, height: '580px',
  width: '800px'},);
  dialogRef.afterClosed().subscribe(data => {
    if(data==false)
    {
    }
    else{
      this.tablaProcedimientos[id]=data;
      //Mapeamos el idProceso y tipo
      data['id_proceso']=this.formProcesos.controls.id_proceso.value;
      data['tipoProceso_procesoDetalle']=0;
      //this.tablaProcedimientos.push(data);
      //Recargamos la tabla
      //this.recargarTabla(this.id_proceso);
    }//Cerrar el else
  //Cerrar ventana modal
 });
}


//Método para editar el modal del proceso AsIs
editarProcedimientoToBe(id:number)
{
  //Convertimos el valor de la tabla en una cadena JSON y la enviamos al modal
  let cadena=JSON.stringify(this.tablaProcedimientosToBe[id]);
  const dialogRef = this.dialog.open(ModalProcedimientoComponent,{data:{data:`${cadena}`, titulo:`Procedimiento Propuesto (To-Be)`},disableClose:true, height: '580px',
  width: '800px'},);
  dialogRef.afterClosed().subscribe(data => {
    if(data==false)
    {
    }
    else{
      this.tablaProcedimientosToBe[id]=data;
      //Mapeamos el idProceso y tipo
      data['id_proceso']=this.formProcesos.controls.id_proceso.value;
      data['tipoProceso_procesoDetalle']=1;
      //this.tablaProcedimientos.push(data);
      //Recargamos la tabla
      //this.recargarTabla(this.id_proceso);
    }//Cerrar el else
  //Cerrar ventana modal
 });
}

 //Eliminar los registros del proceso
 eliminarProcedimientoAsIs(id:number)
 {
   this.tablaProcedimientos.splice(id,1);
 }

 eliminarProcedimientoToBe(id:number)
 {
   this.tablaProcedimientosToBe.splice(id,1);
 }

 //Método para abrir el cuadro de confirmación al eliminar un registro
openDialogConfirmaAsIs(id:number)
{
  let dialogRef = this.dialog.open(ConfirmComponent,{data: `¿Desea eliminar el registro?`,disableClose:true});
  dialogRef.afterClosed().subscribe(result => {
    if(result==false)
    {
      
    }
    else{
      //Eliminamos el registro de la tabla
      this.eliminarProcedimientoAsIs(id);
    }
 });
}


//Método para abrir el cuadro de confirmación al eliminar un registro
openDialogConfirmaToBe(id:number)
{
  let dialogRef = this.dialog.open(ConfirmComponent,{data: `¿Desea eliminar el registro?`,disableClose:true});
  dialogRef.afterClosed().subscribe(result => {
    if(result==false)
    {
      
    }
    else{
      //Eliminamos el registro de la tabla
      this.eliminarProcedimientoToBe(id);
    }
 });
}

descargarArchivoEjemplo()
{
  
  this.dataService.descargarArchivoCosteo().subscribe(res => {
    // Este es necesario para crear un objeto blob con el tipo de archivo
    // puesto explicitamente, de lo contrario solo Chrome funcionara correctamente
    let newBlob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    // IE no permite objetos blob directamente en el atributo href de un link
    // en su lugar hay que usar msSaveOrOpenBlob
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(newBlob);
      return;
    }
    const data = window.URL.createObjectURL(newBlob);
     let link = document.createElement('a');
     link.href = data;
     link.download = "ejemploCosteo";
     // Esta linea es necesaria desde que link.click() ya no funciona en las ultimas versiones de firefox
    link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

    setTimeout(function () {
      // Para Firefox es necesario retrasar la revocacion del objeto ObjectURL
      window.URL.revokeObjectURL(data);
      link.remove();
    }, 100);
  });

}


//Método para leer y mapear el archivo del costeo
onFileChangeCosteo(event: any) 
{
  this.loadingGeneral=true;
  if (event.target.files && event.target.files.length) 
  {
    const [file] = event.target.files;
    this.dataService.subirArchivoCosteo(file,parseInt(this.idIniciativa),0).subscribe( 
      (data: string) => {
        if (data['objData']['proceso']) 
        {
          let infoProceso:Proceso=data['objData']['proceso'];
          this.formProcesos.patchValue({
            id_proceso:data['objData']['listIdProceso'][0],
           // id_proceso:infoProceso.id_proceso,
            nombre_proceso:infoProceso.nombre_proceso,
            procedimiento_proceso:infoProceso.procedimiento_proceso,
            duenio_proceso:infoProceso.duenio_proceso,
            tramitesExternosASIS_proceso:infoProceso.tramitesExternosASIS_proceso,
            tramitesExternosTOBE_proceso:infoProceso.tramitesExternosTOBE_proceso,
            tramitesInternosASIS_proceso:infoProceso.tramitesInternosASIS_proceso,
            tramitesInternosTOBE_proceso:infoProceso.tramitesInternosTOBE_proceso,
            hojasImpresasASIS_proceso:infoProceso.hojasImpresasASIS_proceso,
            hojasImpresasTOBE_proceso:infoProceso.hojasImpresasTOBE_proceso,
            kmRecorridosASIS_Proceso:infoProceso.kmRecorridosASIS_Proceso,
            kmRecorridosTOBE_Proceso:infoProceso.kmRecorridosTOBE_Proceso
          })
                 
          //Si ya tengo procesos guardados, agrego los nuevos
          if(this.tabuladores.length > 0)
          {
             this.valorTaps=this.tabs.length;
            // this.tabSeleccionado=data['objData']['listIdProceso'].length;
             for(let t of data['objData']['listIdProceso'])
             {
               this.tabuladores.push(t);
               //Agregamos los detalles del proceso 
               if(data['objData']['listDetalleProcesos'] && data['objData']['listDetalleProcesos']['id_proceso']==t)
              {
                //Agregamos en la lista los procedimientos
                this.tabla= data['objData']['listDetalleProcesos'];
                for(let numero of this.tabla)
                {
                  if(numero.tipoProceso_procesoDetalle==1)
                  { 
                      this.tablaProcedimientosToBe.push(numero);
                  }
                  else{
                    this.tablaProcedimientos.push(numero);
                  }
                }
              }
             }
          }
          else{
            this.tabuladores=data['objData']['listIdProceso'];
            if(data['objData']['listDetalleProcesos'])
              {
                //Agregamos en la lista los procedimientos
                this.tabla= data['objData']['listDetalleProcesos'];
                for(let numero of this.tabla)
                {
                  if(numero.tipoProceso_procesoDetalle==1)
                  { 
                      this.tablaProcedimientosToBe.push(numero);
                  }
                  else{
                    this.tablaProcedimientos.push(numero);
                  }
                }
              }
          }
              
            /*  if(data['objData']['listDetalleProcesos'])
              {
                //Agregamos en la lista los procedimientos
                this.tabla= data['objData']['listDetalleProcesos'];
                for(let numero of this.tabla)
                {
                  if(numero.tipoProceso_procesoDetalle==1)
                  { 
                      this.tablaProcedimientosToBe.push(numero);
                  }
                  else{
                    this.tablaProcedimientos.push(numero);
                  }
                }
              }*/

              //Cierre del if de la lista
              for(let numero of this.tabuladores)
              {
                this.tabs.push(`Procedimiento ${this.tabs.length + 1}`); 
              }
              if(this.valorTaps!=0)
              {
                this.tabs.splice(this.tabs.length-this.valorTaps, this.valorTaps);

              }
              else{
                  //Eliminamos el ultmo tap
                  this.removeTab(this.tabs.length-1);
              }
              //this.idProceso=data['objData']['proceso']['id_proceso'];
              //Se manda mensaje de guardado
              this.loadingGeneral=false;
              this.notifier.notify('success', 'Costeo de iniciativa registrado correctamente.');

        }
        else{
          let mensaje=data['errorMessage'];
          this.notifier.notify('error',mensaje);
        }
      },
      error => {
        console.error(error); 
      });

      //Resetear el formcontrol
      this.formProcesos.controls['archivo_costeo'].reset();


  }//Cierre del if

}//cierre del método para subir archivo

}//Cierre de la clase


